import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {createSelectionOptionsUtil, isActiveWaitingListEntry} from '../../../Util/commonUtility';
import {useNavigate, useParams} from 'react-router-dom';
import AddAttendeeComponent from '../../../Components/UserComponents/AddAttendees';
import {getEventOptionsByEventId} from './../../../Store/Actions/eventOptions';
import {
  UpdateAttendee,
  applyCouponCodes,
  deleteAttendee,
  getAttendesByUserAndEventId,
  getRegistrationUserWaitingListById,
  normalRegistrationByUserAndEventId,
  postAttendee,
} from './../../../Store/Actions/eventRegister';
import {getAllChapters} from '../../../Store/Actions';
import useLocalization from '../../../Localization';

const AddAttendeeContainer = () => {
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const {ApplicationString} = useLocalization();
  const {allAttendees} = useSelector(({eventRegister}) => eventRegister);
  const {getEventOptionByEventId} = useSelector(
    ({eventOptions}) => eventOptions,
  );
  const {allUserRegistrationWaitingList} = useSelector(
    ({eventRegister}) => eventRegister,
  );
  const [allEventOptionsFoodData, setAllEventOptionsFoodData] = useState([]);
  const [totalCartPrice, setTotalCartPrice] = useState(0);
  const [allEventOptionsRegistrationData, setAllEventOptionsRegistrationData] =
    useState([]);
  const [allRegistrationWaitingList, setAllRegistrationWaitingList] = useState(
    [],
  );

  const [allAttendeesData, setAllAttendeesData] = useState();
  const [eventLocalChapterData, setEventLocalChapterData] = useState();
  const [attendeesData, setAttendeesData] = useState();
  const {id} = useParams();
  const [eventType, setEventType] = useState('');
  const [eventAvailableForWebcast, setEventAvailableForWebcast] = useState({
    isAvailable: false,
    availableChapters: [],
    eventLocalChapter: null,
  });
  const [eventName, setEventName] = useState('');
  const [eventISOnline, setEventISOnline] = useState(false);
  const [isSponsorAvailable, setIsSponsorAvailable] = useState(false);
  const [appliedCartCoupon, setAppliedCartCoupon] = useState();
  const [isAppliedCoupon, setIsAppliedCoupon] = useState(false);
  const userID = JSON.parse(localStorage.getItem('userInfo'))?.id;
  const allChapters = useSelector((state) => state.chapters.allChapters);

  const fetchWaitingList = async (eventId) => {
    try {
      dispatch(getRegistrationUserWaitingListById(eventId, userID));
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (!allChapters) {
      dispatch(getAllChapters());
    }
  }, []);

  useEffect(() => {
    if (allUserRegistrationWaitingList) {
      const waitingList = Array.isArray(
        allUserRegistrationWaitingList?.waitingList,
      )
        ? allUserRegistrationWaitingList.waitingList
        : [];
      setAllRegistrationWaitingList(
        waitingList.filter(
          (item) =>
            isActiveWaitingListEntry(item) &&
            (item?.registration_type || '').toString().toLowerCase() ===
              'registration',
        ),
      );
    } else {
      fetchWaitingList(id);
    }
  }, [allUserRegistrationWaitingList?.waitingList, id]);
  useEffect(() => {
    fetchWaitingList(id);
  }, []);

  useEffect(() => {
    if (getEventOptionByEventId) {
      const filteredRegData =
        getEventOptionByEventId?.data?.registration?.filter(
          (reg) => reg?.is_vendor === false,
        );
      const data = getEventOptionByEventId?.data?.food
        ? createSelectionOptionsUtil(
            getEventOptionByEventId?.data?.food,
            'id',
            'name',
            'price',
            eventLocalChapterData,
          )
        : [];
      const noFoodData = [
        ...data,
        {
          value: 'no-food',
          label: ApplicationString['addAttendeesComponent.label.noFoodOption'],
          price: 0,
        },
      ];
      setAllEventOptionsFoodData(noFoodData);
      setAllEventOptionsRegistrationData(
        createSelectionOptionsUtil(
          filteredRegData,
          'id',
          'name',
          'price',
          eventLocalChapterData,
        ),
      );
    }
  }, [getEventOptionByEventId, eventLocalChapterData]);

  useEffect(() => {
    if (allAttendees) {
      setTotalCartPrice({
        total_price_per_cart: allAttendees?.data?.total_price,
        discount: allAttendees?.data?.discount,
        discounted_price: allAttendees?.data?.discounted_price,
        refund_credit: allAttendees?.data?.refund_credit,
        refund_credit_for_regular_attendees:
          allAttendees?.data?.refund_credit,
      });
      const Data = allAttendees?.data?.event_registrations?.attendees?.filter(
        (obj) => obj.is_reps === false,
      );
      setAllAttendeesData(Data);
      const eventLocalChapterData = allChapters?.data?.chapters?.find(
        (obj) => obj.id === allAttendees?.data?.local_chapter_id,
      );
      setEventLocalChapterData(eventLocalChapterData);
      setAppliedCartCoupon(allAttendees?.data?.discount_code);
      setEventType(allAttendees?.data?.event_type_name);
      setEventName(allAttendees?.data?.event_name);
      setEventISOnline(allAttendees?.data?.is_online);
      setEventAvailableForWebcast({
        isAvailable: allAttendees?.data?.is_available_for_webcast,
        availableChapters: allAttendees?.data?.webcast_available_for_chapters,
        eventLocalChapter: allAttendees?.data?.event_local_chapter,
      });
      setIsSponsorAvailable(allAttendees?.data?.sponsorship_available);
    } else {
      getAttendeeByEventId(id);
    }
  }, [allAttendees, allChapters]);

  useEffect(() => {
    if (isAppliedCoupon) {
      getAttendeeByEventId(id);
      setIsAppliedCoupon(false);
    }
  }, [isAppliedCoupon]);

  useEffect(() => {
    if (allAttendeesData) {
      const Data = Array.isArray(allAttendeesData)
        ? allAttendeesData.map((item) => {
            return {
              ...item,
              food_option: item?.event_registration_options?.food,
              registration_option:
                item?.event_registration_options?.registration,
            };
          })
        : [];
      setAttendeesData(Data);
    }
  }, [allAttendeesData, id]);

  useEffect(() => {
    if (id) {
      dispatch(getEventOptionsByEventId(id));
      getAttendeeByEventId(id);
    }
  }, [id]);

  const AddAttendee = (
    Data,
    setEditingKey,
    form,
    setIsAddAttendee,
    setDisableAttendeeClicks,
    setDisablePaymentClicks,
    setDisableEditClicks,
    setIsSavingAttendee,
  ) => {
    dispatch(
      postAttendee(
        Data,
        setEditingKey,
        form,
        setIsAddAttendee,
        setDisableAttendeeClicks,
        setDisablePaymentClicks,
        setDisableEditClicks,
        setIsSavingAttendee,
      ),
    );
  };
  const getAttendeeByEventId = (id) => {
    const attendeeType = 'normal';
    dispatch(getAttendesByUserAndEventId(id, attendeeType));
  };
  const editAttendeeById = (
    Data,
    id,
    setEditingKey,
    form,
    setDisableAttendeeClicks,
    setDisablePaymentClicks,
    setDisableEditClicks,
    setIsSavingAttendee,
  ) => {
    dispatch(
      UpdateAttendee(
        Data,
        id,
        setEditingKey,
        form,
        setDisableAttendeeClicks,
        setDisablePaymentClicks,
        setDisableEditClicks,
        setIsSavingAttendee,
      ),
    );
  };
  const deleteAttendeeById = (id) => {
    dispatch(deleteAttendee(id));
  };
  const applyCouponCode = async (Data) => {
    dispatch(applyCouponCodes(Data, setIsAppliedCoupon));
  };
  const paymentByUserRegistration = async (eventId) => {
    dispatch(
      normalRegistrationByUserAndEventId(
        eventId,
        navigate,
        totalCartPrice?.discounted_price === 0 ||
          totalCartPrice?.total_price_per_cart === 0,
        true,
      ),
    );
  };
  return (
    <div>
      <AddAttendeeComponent
        isSponsorAvailable={isSponsorAvailable}
        allEventOptionsFoodData={allEventOptionsFoodData}
        allEventOptionsRegistrationData={allEventOptionsRegistrationData}
        inPersonRemaining={getEventOptionByEventId?.data?.in_person_remaining}
        AddAttendee={(
          Data,
          setEditingKey,
          form,
          setIsAddAttendee,
          setDisableAttendeeClicks,
          setDisablePaymentClicks,
          setDisableEditClicks,
          setIsSavingAttendee,
        ) => {
          AddAttendee(
            Data,
            setEditingKey,
            form,
            setIsAddAttendee,
            setDisableAttendeeClicks,
            setDisablePaymentClicks,
            setDisableEditClicks,
            setIsSavingAttendee,
          );
        }}
        getAttendeeByEventId={getAttendeeByEventId}
        editAttendeeById={(
          Data,
          id,
          setEditingKey,
          form,
          setDisableAttendeeClicks,
          setDisablePaymentClicks,
          setDisableEditClicks,
          setIsSavingAttendee,
        ) => {
          editAttendeeById(
            Data,
            id,
            setEditingKey,
            form,
            setDisableAttendeeClicks,
            setDisablePaymentClicks,
            setDisableEditClicks,
            setIsSavingAttendee,
          );
        }}
        deleteAttendeeById={(id) => {
          deleteAttendeeById(id);
        }}
        attendeesData={attendeesData}
        setAttendeesData={setAttendeesData}
        totalCartPrice={totalCartPrice}
        eventType={eventType}
        eventAvailableForWebcast={eventAvailableForWebcast}
        eventName={eventName}
        allAttendeesData={allAttendeesData}
        allRegistrationWaitingList={allRegistrationWaitingList}
        paymentByUserRegistration={paymentByUserRegistration}
        applyCouponCode={applyCouponCode}
        appliedCartCoupon={appliedCartCoupon}
        eventLocalChapterData={eventLocalChapterData}
        eventISOnline={eventISOnline}
      />
    </div>
  );
};

export default AddAttendeeContainer;
